import { useEffect, useRef } from 'react';

export default function UnsavedChangesDialog({ state, onDecision }) {
  const ref = useRef(null);
  const stay = useRef(null);
  useEffect(() => {
    if (state) { ref.current.showModal(); stay.current.focus(); }
    else if (ref.current.open) ref.current.close();
  }, [state]);
  return <dialog ref={ref} className="carrier-dialog" dir="rtl" aria-labelledby="carrier-unsaved-title"
    onCancel={(event) => { event.preventDefault(); onDecision(false); }}>
    <h2 id="carrier-unsaved-title">تغییرات ذخیره‌نشده</h2>
    <p>این تغییرات هنوز ذخیره نشده‌اند:</p>
    <ul>{state?.labels.map((label, index) => <li key={index} dir="auto">{label}</li>)}</ul>
    <p>اگر ادامه دهید، این تغییرات از بین می‌رود.</p>
    <div className="carrier-dialog-actions">
      <button ref={stay} type="button" className="carrier-button" onClick={() => onDecision(false)}>ماندن در همین صفحه</button>
      <button type="button" className="carrier-button carrier-button-danger" onClick={() => onDecision(true)}>
        {state?.destination ? `دور ریختن و رفتن به ${state.destination}` : 'دور ریختن و ادامه'}
      </button>
    </div>
  </dialog>;
}
